<main id="main" class="container">

      <div class="sections">

            <section id="headeContent" class="box-card d-flex align-items-center z-depth-5 section">
                  <div class="container-fluid">
                        <div id="success" class="toast-alert alert-danger hide notificationheight" role="alert"
                              data-autohide="false" aria-live="assertive" aria-atomic="true">

                              <div class="toast-body col">
                                    <i class="fas fa-2x fa-exclamation-circle ms-2" aria-hidden="true"></i>
                                    <span contenteditable>{{alertMsg}}</span>
                              </div>
                        </div>
                        <!-- <div notificationheight>
                          <strong class="me-auto" style="color:red;">{{alertMsg}}</strong>
                          </div> -->
                        <div class="row justify-content-center mt-3">
                              <div class="col-xl-6 col-lg-6 pt-3 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
                                    <div>
                                          <h1 class="fw-bolder ms-5">{{ContentHeader}}</h1>
                                          <div class="box-card card-body z-depth-5 col-lg-10 col-md-12 pt-3 ms-5 ">
                                                <h5>
                                                      <p class="card-text text-justify text-break textheight mb-2 ">
                                                            <!-- {{ContentBody}} -->
                                                            <strong>Accenture System Diagnostic (ASD)</strong> is
                                                            an Accenture proprietary capability that offers
                                                            technical diagnostic assessment solutions for various
                                                            SAP systems. ASD offers insightful diagnostic reports
                                                            that can provide deep technical insights into your SAP
                                                            systems.
                                                      </p>
                                                      <p class="alighRight mt-2">
                                                            <a  href="#aboutUs" id="readMore"
                                                                  class="scrollto text-uppercase alink">
                                                                  Read More</a>
                                                            <i class="fas fa-long-arrow-alt-right"></i>
                                                      </p>
                                                </h5>
                                                <div class="text-center  pt-5">
                                                      <a  href="#offering" type="button" id="btnStarted"
                                                            class="basebtn scrollto text-uppercase">Get
                                                            Started 
                                                            <i class=" scrollarrow fas fa-angle-double-down"></i></a>
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div class="col-xl-6 col-lg-6 order-1 order-lg-2  headeContent-img ">
                                    <div class="row">
                                          <img src="./assets/Images/Header/headerImage.jpg" class="img-fluid" alt=""> 
                                    </div>
                                    <div class="row" style="margin-top:-50px">
                                          <div class="col-md-4">
                                                <h3 class="fw-bolder textcolor text-uppercase">DEFINE</h3>
                                                <h6 class="textfadecolor ms-2" style="margin-top:-10px">The Scope</h6>
                                          </div>
                                          <div class="col-md-4">
                                                <h3 class="fw-bolder textcolor text-uppercase">DIAGNOSE</h3>
                                                <h6 class="textfadecolor ms-4" style="margin-top:-10px">The System</h6>
                                          </div>
                                          <div class="col-md-4">
                                                <h3 class="fw-bolder textcolor text-uppercase">DISCOVER</h3>
                                                <h6 class="textfadecolor ms-4" style="margin-top:-10px">The Insights
                                                </h6>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div class="row justify-content-center">
                              <p class="mod-singular-pager text-center">
                                    <a href="#aboutUs"
                                          class="mod-singular-next js-singular-next scrollto z-depth-5 scrollarrow"
                                          matTooltip ="Our capability" placement="right"></a>
                              </p>
                        </div>
                        <span>
                        </span>
                  </div>
            </section>
            <app-about-us></app-about-us>
            <app-offering></app-offering>
            <app-deployment-approach></app-deployment-approach>
      </div>
</main>